module.exports = __webpack_public_path__ + "static/assets/dc63f7dfb6262c69019fe9bd75037231.png";